import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function FloatingReview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const reviews = [{
    quote: 'Exceptional quality and fast turnaround.',
    author: 'James M.',
    role: 'Manufacturing Director'
  }, {
    quote: 'Our go-to supplier for compliance labels.',
    author: 'Sarah L.',
    role: 'Procurement Manager'
  }, {
    quote: '25 years of reliable partnership.',
    author: 'David K.',
    role: 'Operations Lead'
  }];
  useEffect(() => {
    const startTimer = setTimeout(() => setIsVisible(true), 3000);
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % reviews.length);
        setIsVisible(true);
      }, 500);
    }, 7000);
    return () => {
      clearTimeout(startTimer);
      clearInterval(interval);
    };
  }, [reviews.length]);
  return <div className="fixed bottom-6 left-6 z-40 hidden lg:block" data-id="element-75">
      <AnimatePresence data-id="element-76">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-[#F0F7FF] p-5 rounded-2xl shadow-xl shadow-slate-300/40 border border-[#0052CC]/10 max-w-xs" data-id="element-77">
            <div className="flex items-start gap-3 mb-3" data-id="element-78">
              <Quote className="h-5 w-5 text-[#0052CC] flex-shrink-0 mt-0.5" data-id="element-79" />
              <p className="text-[#0A1628] text-base font-medium leading-snug" data-id="element-80">
                {reviews[currentIndex].quote}
              </p>
            </div>
            <div className="flex items-center justify-between" data-id="element-81">
              <div className="flex items-center" data-id="element-82">
                <div className="h-8 w-8 rounded-full bg-[#0052CC] flex items-center justify-center text-white font-bold text-xs mr-2" data-id="element-83">
                  {reviews[currentIndex].author.charAt(0)}
                </div>
                <div data-id="element-84">
                  <p className="text-sm font-bold text-[#0A1628]" data-id="element-85">
                    {reviews[currentIndex].author}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-86">
                    {reviews[currentIndex].role}
                  </p>
                </div>
              </div>
              <div className="flex gap-0.5" data-id="element-87">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="h-3 w-3 text-[#0052CC] fill-current" data-id="element-88" />)}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}